export default __webpack_public_path__ + "static/media/plus_delta.2a2b2ec5.png";